const incomeOptions = [
  { label: 'Less than $30,000', value: '< $30,000' },
  { label: '$30,000 - $50,000', value: '$30,000 - $50,000' },
  { label: '$50,000 - $80,000', value: '$50,000 - $80,000' },
  { label: '$80,000 - $120,000', value: '$80,000 - $120,000' },
  { label: '$120,000+', value: '$120,000+' },
];

export default incomeOptions;
